module.exports = "//public.zight.com/packs/media/images/your_plan_badge@2x-81620d0e0aa385f460e634261cf4f758.png";